import { render, staticRenderFns } from "./TemplateDefault.vue?vue&type=template&id=38d11ff3&scoped=true&"
import script from "./TemplateDefault.ts?vue&type=script&lang=ts&"
export * from "./TemplateDefault.ts?vue&type=script&lang=ts&"
import style0 from "./TemplateDefault.scss?vue&type=style&index=0&id=38d11ff3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d11ff3",
  null
  
)

export default component.exports